export default __webpack_public_path__ + "static/1-c3aec2a90c97bc348b542e7e6cf4975f.jpeg";